import { h } from "preact";
import projectData from "./projectData.json";
import "./corner_styles.css";

export default function ProjectsPage() {
  return (
    <main class="corner-page content-page">
      <p class="eyebrow">Projects</p>
      <h1>Things I've built because I felt like it</h1>
      <p class="page-intro">Some started as homework. Some started because I asked myself, "I wonder if I could build that?" Those usually ended up being the fun ones. </p>
      <a class="primary-link" href="https://github.com/celinaryan" target="_blank" rel="noopener noreferrer">Check out my GitHub <span class="link-arrow" aria-hidden="true"></span></a>
      <div class="projects-divider" aria-hidden="true"></div>
      <div class="project-list">
        {projectData.map((project) => (
          <article class="project-card" key={project.projectTitle} data-scroll-reveal>
            <p class="project-meta">{project.projectDates}</p>
            <h2>{project.projectTitle}</h2>
            <p class="project-context">{project.projectName}</p>
            <ul>
              {project.projectDescription.map((detail) => <li key={detail}>{detail}</li>)}
            </ul>
            {project.pdfs && project.pdfs.map((pdf) => <a class="project-file" href={`/${pdf}`} target="_blank" rel="noopener noreferrer" key={pdf}>Project document <span class="link-arrow" aria-hidden="true"></span></a>)}
          </article>
        ))}
      </div>
    </main>
  );
}
